// AUTO-GENERATED by scripts/set-env.ts — do not edit directly.
export const environment = {
  production: false,
  apiUrl: '/v1',
  firebase: {
    apiKey: "AIzaSyCELQ0jNc_3UjBZVBQiT_ScKrBCsoLUSDQ",
    authDomain: "ask-scotty-sandbox.firebaseapp.com",
    projectId: "ask-scotty-sandbox",
    storageBucket: "ask-scotty-sandbox.appspot.com",
    messagingSenderId: "593894221861",
    appId: "1:593894221861:web:333f77df6aca85bf2f37cc",
    measurementId: "G-50W829PNWL"
  }
};
